import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-psychology',
  templateUrl: './psychology.component.html',
  styleUrls: ['./psychology.component.scss']
})
export class PsychologyComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
